<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Unearthed</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By BA Tortuga</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Some ancient secrets are better left buried….</p>
<p class="P_Normal">When Jacob Keys gets the call every man dreads, he leaves his Wyoming home to find his mother’s killer. A whole archaeological team in Sardinia is dead, all of the bodies accounted for—all but Caleb Paulsen, consummate scholar and Jacob’s former lover. In Italy, Jacob sets out to discover the cause of the tragedy. And to find Caleb.</p>
<p class="P_Normal">Meanwhile, a shipment arrives for Jacob in Wyoming. Jacob’s friend, Ben Walking Turtle, and his partner, Sam MacDougal, retrieve the box… and with it, a ruthless and cunning entity that’s been biding its time.</p>
<p class="P_Normal">From Sardinia to Wyoming, Phoenix to Denver, this lethal ancient evil travels toward its bitter last stand, leaving death and destruction in its wake.</p>
<p class="P_Normal">None of the men who touch it will ever be the same.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?e122e994